/**
 * Simple service for calling the Collections API from WebSked
 * @author Brendan Magee
 */

function collectionsService($http, $log) {
  const service = {
    basePath: '/websked/collections/api'
  };

  service.getUsage = storyId => (
    $http.get(`${service.basePath}/v1/usage/${storyId}`)
      .then((response) => {
        if (response && Array.isArray(response.data)) {
          return response.data;
        }

        return [];
      })
  );

  service.getUsages = storyIds => (
    $http.get(
      `${service.basePath}/v1/usage/bulk`,
      { params: { contentIds: storyIds.join(',') } }
    )
  );

  // Handles stories as well as tasks with associated stories
  service.addUsagesToStories = async (list, dataType = 'story') => {
    try {
      if (list.length < 1) {
        return list;
      }

      const contentIds = dataType === 'story'
        ? list.map(story => story.id)
        : list.reduce((acc, task) => {
          if (task.storyID) {
            acc.push(task.storyID);
          }
          return acc;
        }, []);

      if (contentIds.length < 1) {
        return list;
      }

      const { data: usages } = await service.getUsages(contentIds);

      return list.map((item) => {
        if (dataType === 'task' && item.storyID && usages[item.storyID]) {
          return { ...item, story: { ...item.story, collections: usages[item.storyID] } };
        } else if (dataType === 'story' && usages[item.id]) {
          return { ...item, collections: usages[item.id] };
        }

        return item;
      });
    } catch (error) {
      $log.error('Error adding Collections usage to stories', error);
    }

    return list;
  };

  service.removeContentFromCollection = (collectionId, contentId) => $http.delete(
    `${service.basePath}/v3/collections/${collectionId}/content/${contentId}`
  );

  service.moveToTop = (collectionId, contentId) =>
    $http.post(`${service.basePath}/moveToTop/`, { collectionId, contentId });

  service.moveToBottom = (collectionId, contentId) =>
    $http.post(`${service.basePath}/moveToBottom/`, {
      collectionId,
      contentId
    });

  return service;
}

const serviceArray = [
  '$http',
  '$log',
  collectionsService
];

module.exports = (ngModule) => {
  ngModule.factory('collectionsService', serviceArray);
};
